import type { ApolloClient } from '@apollo/client';

// TRIL-500: after publishing, the author should see their new post immediately. The feed route
// can stay mounted across the post-publish redirect, so evicting `getUserFeed` from the cache
// (in addPost's `update()`) does NOT force the live feed observer to refetch — it only reloads
// on a fresh mount, which is the "navigate away and come back" symptom.
//
// Actively refetching the two author-visible lists by operation name re-runs whichever ones are
// currently mounted (the feed, and the profile posts page if open), regardless of mount timing.
// We target these two specifically rather than `include: 'all'`, which would refetch every active
// query and is needlessly expensive. Mirrors the mobile fix (evictFeedAfterPublish, PR #402).
export function refetchAuthorFeedsAfterPublish(
  client: ApolloClient<object>,
): void {
  void client.refetchQueries({ include: ['getUserFeed', 'getUserPosts'] });
}
